import React from "react";
import {Image} from "@mantine/core";

const OrgLinkLine = () => {
    return (
        <div>
            <Image
                src={`/images/orgLine-1.png`}
                width={2}
                height={26}
            />
        </div>
    );
}

export default OrgLinkLine;
